"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ObjectTyped = void 0;
var ObjectTyped;
(function (ObjectTyped) {
    ObjectTyped.keys = function (o) { return Object.keys(o); };
    ObjectTyped.entries = function (o) {
        return Object.entries(o);
    };
})(ObjectTyped = exports.ObjectTyped || (exports.ObjectTyped = {}));
